module.exports = __webpack_public_path__ + "static/img/ChineseManual.defa5e7c.png";